module.exports = __webpack_public_path__ + "img/1163871694.3f6a79ac.jpg";